import { useEffect, useState } from 'react';
import { Button, Form, Row } from 'react-bootstrap';
import { UserService } from '../../user/UserService';
import { IUser } from '../../../model/user/IUser';
import { CampaignsService } from '../../campaigns/CampaignsService';
import { Campaign } from '../../../model/campaign/Campaign';
import AutocompleteInput from '../../../shared/components/AutocompleteInput';
import { ErrorToast } from '../../../utils/toasters';
import { AgencyService } from '../../agency/AgencyService';
import { useNavigate } from 'react-router-dom';

interface IIncomingDeferralFilter {
    handleState: (...arg: any) => void;
    setState: (...arg: any) => void;
    offersFilter: any;
}

export function IncomingDeferralFilter({ handleState, setState, offersFilter }: IIncomingDeferralFilter) {
    const navigate = useNavigate();
    const [users, setUsers] = useState<IUser[]>([]);
    const [campaigns, setCampaigns] = useState<Campaign[]>([]);
    const [campaignFilter, setCampaignFilter] = useState('');
    const [influencerFilter, setInfluencerFilter] = useState('');
    const [companyFilter, setCompanyFilter] = useState('');
    const [companyDropdown, setCompanyDropdown] = useState<IUser[]>([]);

    useEffect(() => {
        UserService.getUsers({ perPage: 15, userType: 'influencer', displayName: influencerFilter })
            .then(data => {
                setUsers(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [influencerFilter]);
    useEffect(() => {
        AgencyService.getAgencies({ displayName: companyFilter, perPage: 15 })
            .then(data => {
                setCompanyDropdown(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [companyFilter]);
    useEffect(() => {
        CampaignsService.getCampaigns({ perPage: 15, title: campaignFilter, isLongTerm: false })
            .then(data => {
                setCampaigns(data.data);
            })
            .catch(err => ErrorToast(err));
    }, [campaignFilter]);

    function handleChanges(evt: React.ChangeEvent<HTMLInputElement>) {
        const { name, value } = evt.target;
        setState({
            ...offersFilter,
            [name]: value,
            page: 1,
        });
    }

    return (
        <Form>
            <Row style={{ rowGap: '18px' }}>
                <div className="col-md-3 col-6">
                    <Form.Control
                        placeholder="Incoming deferral ID"
                        className="autocomplete-input"
                        name="id"
                        onChange={handleChanges}
                    />
                </div>
                <div className="col-md-3 col-6">
                    <AutocompleteInput
                        placeholder="Campaign name or ID"
                        onSelect={campaign => {
                            setState({
                                ...offersFilter,
                                campaignId: campaign.id,
                                page: 1,
                            });
                        }}
                        setFilter={setCampaignFilter}
                        value={campaignFilter}
                        items={campaigns}
                        hasClearBtn
                        renderItems={['id', 'title']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                campaignId: undefined,
                                page: 1,
                            });
                            setCampaignFilter('');
                        }}
                    />
                </div>
                <div className="col-md-3 col-6 autocomplete-input">
                    <AutocompleteInput
                        placeholder="Influencer name"
                        onSelect={user => {
                            setState({
                                ...offersFilter,
                                influencerId: user.id,
                                page: 1,
                            });
                        }}
                        setFilter={setInfluencerFilter}
                        value={influencerFilter}
                        items={users}
                        hasClearBtn
                        renderItems={['id', 'displayName']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                influencerId: undefined,
                                page: 1,
                            });
                            setInfluencerFilter('');
                        }}
                    />
                </div>
                <div className="col-md-3 col-6">
                    <AutocompleteInput
                        placeholder="Agency name or ID"
                        onSelect={company => {
                            setState({
                                ...offersFilter,
                                agencyId: company.id,
                                page: 1,
                            });
                        }}
                        setFilter={setCompanyFilter}
                        value={companyFilter}
                        items={companyDropdown}
                        hasClearBtn
                        renderItems={['id', 'displayName']}
                        clearFunc={() => {
                            setState({
                                ...offersFilter,
                                agencyId: undefined,
                                page: 1,
                            });
                            setCompanyFilter('');
                        }}
                    />
                </div>
            </Row>
            <div className="d-flex justify-content-between mt-4">
                <Button onClick={() => handleState(offersFilter)}>Search</Button>
                <Button variant="outline-primary" onClick={() => navigate('/controlling/deferral-list')}>
                    Deferral List
                </Button>
            </div>
        </Form>
    );
}
